import React, { Component } from 'react'
import {
    Container,
    Form,
    Button,
    Nav,
    NavItem,
    NavLink
} from 'reactstrap';

class conclude9_1 extends Component {
    render() {
        return (
            <div>
                <Container className="comming">
                <Form className="boxrandomtest">
                        <h1 className="textrandomtest1">แบบทดสอบวัดระดับ</h1>
                        <Form className="Q1">
                           <h3 h5 align='center'>คะแนนที่คุณได้</h3>  <br></br>
                           <h1 h5 align='center'>1</h1><br></br>
                           <p  h5 align='center'><Button href='/review9_1' color="#4fc3f7 light-blue lighten-2" >review</Button>{' '}</p>
                           <p  h5 align='center'><Button href='/randomtest' color="#4fc3f7 light-blue lighten-2" >กลับหน้าหลัก</Button>{' '}</p>
                        </Form>
                       
                </Form>
                </Container>
               
                <div className="footer text-footer">
                    <p>Surasak   Noorurk</p>
                    <p> Project 5935512072 Computer Engineering</p>
                    <NavLink href="https://www.facebook.com/few.connectfve">ช่องทางการติดต่อ</NavLink>
                       
                </div>

            </div> 
        )
    }
}

export default conclude9_1